import {GameResource} from "../resource/GameResource";

export class GameService {

    public static $inject = ["GameResource"];
    constructor(private GameResource: GameResource) {}

    public getName(id: number): angular.IPromise<string> {
        return this.GameResource.getName(id);
    }
}
